class ImageScroll {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-imagescroll',
            contentAttr: 'content',
            imageAttr: 'image',
            mediaTargetAttr: 'media-target',
            scrollerAttr: 'scroller'
        };

        this.settings = Object.assign({}, defaults, options);

        this.$imageScroll = $element;
        this.$imageScrollScroller = this.$imageScroll.querySelector('[' + this.settings.initAttr + '="' + this.settings.scrollerAttr + '"]');
        this.$imageScrollContents = this.$imageScroll.querySelectorAll('[' + this.settings.initAttr + '="' + this.settings.contentAttr + '"]');
        this.$imageScrollMediaTarget = this.$imageScroll.querySelector('[' + this.settings.initAttr + '="' + this.settings.mediaTargetAttr + '"]');

        if (this.$imageScrollScroller && this.$imageScrollMediaTarget) {
            this.initialize();
        }
    }

    initialize () {
        this.cloneImages(() => {
            this.setEvents();
            this.checkPosition();
        });
    }

    setEvents () {
        let ticking = false;
        this.$imageScrollScroller.addEventListener('scroll', () => {
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    this.checkPosition();
                    ticking = false;
                });

                ticking = true;
            }
        }, { passive: true });
    }

    cloneImages (callback) {
        let ready = false;
        for (let i = 0; i < this.$imageScrollContents.length; i++) {
            const $content = this.$imageScrollContents[i];
            const $contentImage = $content.querySelector('[' + this.settings.initAttr + '="' + this.settings.imageAttr + '"]');

            if ($contentImage) {
                this.$imageScrollMediaTarget.appendChild($contentImage.cloneNode(true));
            }

            if (i === this.$imageScrollContents.length - 1) {
                ready = true;
            }
        }

        if (ready === true) {
            this.$targetImages = this.$imageScrollMediaTarget.querySelectorAll('[data-index]');

            if (typeof callback === 'function') {
                callback();
            }
        }
    }

    checkPosition () {
        const scrollerHeight = this.$imageScrollScroller.offsetHeight;
        const scrollTopPosition = parseInt(this.$imageScrollScroller.scrollTop);

        for (let i = 0; i < this.$imageScrollContents.length; i++) {
            const $currentContent = this.$imageScrollContents[i];
            const currentContentTopPosition = $currentContent.offsetTop;

            if (scrollTopPosition + (scrollerHeight / 2) >= currentContentTopPosition) {
                this.setActiveContent($currentContent, i);
            } else {
                this.unsetActiveContent($currentContent, i);
            }
        }
    }

    setActiveContent ($content, index) {
        $content.classList.add('is--active');

        if (this.$imageScrollMediaTarget.querySelector('[data-index="' + index + '"]')) {
            const $currentActive = this.$imageScrollMediaTarget.querySelector('.is--active');
            if ($currentActive) {
                $currentActive.classList.remove('is--active');
            }
            /*
            this.$targetImages.forEach(($image) => {
                $image.classList.remove('is--active');
            });
            */

            this.$imageScrollMediaTarget.querySelector('[data-index="' + index + '"]').classList.add('is--active');
        }
    }

    unsetActiveContent ($content, index) {
        $content.classList.remove('is--active');
    }
}

export { ImageScroll };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$videoScroll = $context.querySelectorAll('[data-videoscroll="root"]');
        $$videoScroll.forEach(($videoScroll) => {
            const videoScroll = new VideoScroll($videoScroll); // eslint-disable-line
        });

        const $$imageScroll = $context.querySelectorAll('[data-imagescroll="root"]');
        $$imageScroll.forEach(($imageScroll) => {
            const imageScroll = new ImageScroll($imageScroll); // eslint-disable-line
        });
    }
});
